<template>
  <table :class="table_class">
    <!-- <table class="ui celled striped table"> -->
    <slot name="columns_content">
      <thead>
        <tr v-if="editable || deletable || duplicatable">
          <td class="column_0"></td>
          <td
            v-for="(data, index) in table.items"
            :key="index"
            class="column_1"
          >
            <div class="flex">
              <button
                v-if="editable"
                class="ui icon button purple mini compact"
                @click="$emit('edit_clicked', data)"
              >
                <i class="icon edit"></i>
              </button>
              <button
                v-if="deletable"
                class="ui icon button red mini compact"
                @click="$emit('delete_clicked', data)"
              >
                <i class="icon trash"></i>
              </button>
              <button
                v-if="duplicatable"
                class="ui icon button orange mini compact"
                @click="$emit('duplicate_clicked', data)"
              >
                <i class="icon copy"></i>
              </button>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(col, index) in columns" :key="index">
          <td :class="col.class">{{ col.name }}</td>
          <td v-for="(data, index) in table.items" :key="index">
            <slot :name="col.id" :item="data" :data="data[col.id]">{{
              data[col.id]
            }}</slot>
          </td>
        </tr>
      </tbody>
    </slot>
  </table>
</template>
<style scoped>
.column_0 {
  width: 150px;
  min-width: 160px;
}

.column_1 {
  width: 80px;
}

.flex {
  width: 80px;
  display: flex;
  justify-content: space-around;
}

.tops {
  background-color: aliceblue;
}

.alter {
  background-color: beige;
}

.bottoms {
  background-color: lightblue;
}
</style>
<script>
export default {
  name: 'Datatable',
  props: {
    columns: {
      type: Array,
      default: null
    },
    fetch: {
      type: Function,
      default: () => {}
    },
    display_header: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    duplicatable: {
      type: Boolean,
      default: false
    },
    empty_cell: {
      type: Boolean,
      default: false
    },
    table_class: {
      type: String,
      default: ''
    },
    column_widths: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      table: {
        items: []
      },
      pagination: {
        page: 1,
        size: 50
      },
      filters: {},
      selected: {},
      selectAll: false
    }
  },
  computed: {},
  watch: {
    pagination: {
      handler() {
        this.fetchData()
      },
      deep: true
    },
    selectAll(val) {
      Object.keys(this.table.items).forEach((i) => {
        this.selected[this.table.items[i][this.primary_key]] = val
      })
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const self = this
      this.fetch((data) => {
        self.table.items = data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Datatable.vue?6af6a399